import { orderAction } from "../const";
export const createOrder = (data: any) => {
    return {
        type: orderAction.CREATE_ORDER,
        payload: data,
    };
};
